import { SpvPerformance } from "../models/spv";
import axiosConfig from "./axiosConfig";

const getSpv = async (
  authToken: string,
  orgId: string,
  spvId: string,
  userOrgId?: string
): Promise<{ spvPerformance: SpvPerformance }> => {
  const { data } = await axiosConfig.get(
    `/organisation/${orgId}/spv/${spvId}${userOrgId ? `?userOrgId=${userOrgId}` : ""}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getSpv;
